import * as actions from './actions';

export type State = {
  tempScenario: Record<string, any>;
  error: Record<string, any>;
  modelledScenario?: Record<string, any>;
  updatedFields: Record<string, any>;
};

export default (
  state: State = {
    tempScenario: {},
    modelledScenario: {},
    error: {
      hasParticipantStartError: false,
      hasParticipantEndError: false,
      participantErrorMessage: '',
      hasSpouseError: false,
      spouseErrorMessage: '',
      showAdviceMessage: false,
    },
    updatedFields: {},
  },
  action: any,
): State => {
  switch (action.type) {
    case actions.SET_INITIAL_STATE_FOR_RETIREMENT_AGE:
      return {
        ...state,
        tempScenario: {
          ...action.payload,
        },
        modelledScenario: {
          ...action.payload,
        },
        updatedFields: {},
      };
    case actions.UPDATE_RETIREMENT_AGE_DATA:
      return {
        ...state,
        tempScenario: {
          ...state.tempScenario,
          ...action.payload,
        },
        updatedFields: {
          ...state.updatedFields,
          ...action.payload,
        },
      };
    case actions.MODEL_RETIREMENT_AGE_SCENARIO:
      return {
        ...state,
        modelledScenario: state.tempScenario,
      };
    case actions.UPDATE_RETIREMENT_AGE_ERROR:
      return {
        ...state,
        error: {
          ...state.error,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
